// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wj8Wp0C-XrXAxNvMGDbms"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/Save/styles.css
// module id = 3306
// module chunks = 0